module.exports = __webpack_public_path__ + "img/fjalltalt.113adb78.jpg";